import React, { useContext, useEffect } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import useSticky from 'hooks/useSticky';
import useMatchMedia from 'hooks/useMatchMedia';
import ClearFilters from 'components/ClearFilters';
import { SearchForm } from 'components/ResolveHeader/components/SearchForm';
import OverflowMenu from '../../private/subrouters/Portfolio/components/OverflowMenu/OverflowMenu.component';
import { MainLayoutContext } from 'router/subrouters/Dash/Dash.router';

import './BusinessesFilters.styles.scss';

type BusinessesFiltersProps = {
  className?: string;
  fields: string[];
};

const BusinessesFilters: React.FC<BusinessesFiltersProps> = (props) => {
  const { children, className, fields } = props;

  const isPhablet = useMatchMedia('isPhablet');

  const { addDashClassName, resetDashClassName } =
    useContext(MainLayoutContext);

  const { ref, isSticky } = useSticky();

  const { t } = useTranslation();

  const classes = classNames('businesses-filters', className);

  useEffect(() => {
    if (isSticky) {
      addDashClassName('white-header');
    } else {
      resetDashClassName();
    }

    return () => resetDashClassName();
  }, [addDashClassName, isSticky, resetDashClassName]);

  return (
    <div ref={ref} className={classes}>
      <div>
        {isPhablet ? (
          <OverflowMenu title={t('filters')}>{children}</OverflowMenu>
        ) : (
          children
        )}

        {isSticky && <SearchForm />}

        <ClearFilters filters={fields} />
      </div>
    </div>
  );
};

export default BusinessesFilters;
